import { AromaType } from '~/enums/contents';

export const getAromaImageUrl = (aroma: number, type?: AromaType) => {
  if (type === AromaType.CONTENTS) {
    return `/images/fragrance/contents/img-fragrance_${aroma.toString().padStart(2, '0')}.png`;
  }

  return `/images/fragrance/other/img-fragrance_${aroma.toString().padStart(2, '0')}.png`;
};
